import { render } from "./adminuser.vue?vue&type=template&id=5ba66272"
import script from "./adminuser.vue?vue&type=script&lang=ts"
export * from "./adminuser.vue?vue&type=script&lang=ts"
script.render = render

export default script